import React, { Fragment } from 'react';
import DropdownNew from 'src/ui/library/DropdownNew';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from 'src/ui/library/Checkbox';
import Grid from '@material-ui/core/Grid';
import intl from 'react-intl-universal';
import Hidden from '@material-ui/core/Hidden';
import Button from 'src/ui/library/Button';
import TextInput from 'src/ui/library/TextInput';

const UpdateAppPres = props => {
  return (
    <Fragment>
      <header className="header-section">
        <h1>{props.activeTabType}</h1>
        <section className="page-description">Current Active App Version is {props.activeAppVersion.version}</section>
      </header>
      <section className="content-section">
        {!props.isAddClicked ? (
          <Grid container>
            <Grid item xs={12} className="grid-space">
              <DropdownNew
                id={`appVersion`}
                name={`appVersion`}
                className="dropdown"
                options={props.appVersions.map(item => {
                  return { label: item.version, value: item.appVersionId };
                })}
                label={intl.get('appUpdate.label.appVersion')}
                value={props.appVersionId}
                InputLabelProps={{ shrink: true }}
                disableUnderline={true}
                onChange={props.selectDropDown}
                isDisabled={false}
                required={true}
                isSearchable={true}
              />
              <a href="javascript:void(0);" onClick={() => props.updateAddClicked(true)}>
                Add new app version
              </a>
            </Grid>
          </Grid>
        ) : (
          <Grid container>
            <Grid item xs={12} className="grid-space">
              <TextInput
                label={intl.get('appUpdate.label.appVersion')}
                value={props.appVersion}
                id="newAppVersion"
                onChange={props.handleVersionInputChange}
              />
              <a href="javascript:void(0);" onClick={() => props.updateAddClicked(false)}>
                Cancel
              </a>
            </Grid>
          </Grid>
        )}
        <Grid container>
          <Grid item xs={12} className="grid-space">
            <FormControlLabel
              control={<Checkbox checked={props.activate} value={'activate'} disabled={false} onChange={props.toggleActivate} />}
              label={intl.get('appUpdate.label.activate')}
            />
          </Grid>
        </Grid>
      </section>
      <div className="admin-actions">
        <div className="actions-button-wrapper">
          <Hidden xsDown>
            <Button
              styleType="secondary"
              className="action-button"
              onClick={e => {
                //resetCaseUpload(e);
                props.history.goBack();
              }}>
              {intl.get('default.label.cancel')}
            </Button>
          </Hidden>
          <Button
            className="action-button"
            disabled={false} //isDisabled}
            onClick={e => {
              props.handleSaveClick();
            }}>
            {intl.get('default.label.finish')}
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default UpdateAppPres;
